// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","dropdownLayover":"_3vsTE4vW3L2Kp0m8","dropdownBody":"_2F08r2oYCxAawmy0"};